import { useEffect, useState } from 'react';

const loaders = import.meta.glob('@/assets/lotties/**/*.json', { import: 'default' });

export const useDynamicLottie = (key: string) => {
  const [ data, setData ] = useState<any>(null);
  const [ loading, setLoading ] = useState(true);
  const [ error, setError ] = useState<Error | null>(null);

  useEffect(() => {
    if (!key) {
      setError(new Error('Lottie file not found'));
      setData(null);
      return setLoading(false);
    }

    const path = `/src/assets/lotties/${key}.json`;
    const load = loaders[path] as (() => Promise<any>) | undefined;
    if (!load) {
      setError(new Error('Lottie file not found'));
      setData(null);
      return setLoading(false);
    }

    load().then((mod) => { setData(mod); setError(null); })
          .catch((err) => setError(err as Error))
          .finally(() => setLoading(false));
  }, [ key ]);

  return { data, loading, error };
};